
export enum ObservationTypes {
  ASH = '1',
  S02 = '2',
  REPORT = '3',
  GAS = '4',
  RESUSPENDED_ASH = '5',
  ERUPTION = '6',
  INGV_VESUVIOUS_OBSERVATION = '7',
  INGV_ETNA_OBSERVATION = '8',
  GROUND_CRACK_DEFORMATION = '9',
  HEARD_BOOM = '10',
  EARTH_SHAKE = '11',
  INGV_SEISMIC_EVENT = '12',
}
